import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import React from 'react'

import Button from '@/app/component/atom/button'
import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog/header'
import CampaignSelect from '@/app/module/campaigns/component/campaign-select'
import { BackendCampaignTemplate, LocalPickupAction } from '@/app/module/campaigns/types'
import ZPickupAction from '@/app/module/campaigns/types/schemas/actions/pickup'

type Props = {
  value: LocalPickupAction
  onClose: () => void
  onSave: (action: Pick<LocalPickupAction, 'pickUp'>) => void
}

const Pickup: React.FC<Props> = ({ value, onClose, onSave }) => {
  const [campaignId, setCampaignId] = React.useState(value.pickUp.campId)
  const action = { id: value.id, pickUp: { campId: campaignId } }
  const valid = ZPickupAction.safeParse(action).success

  return (
    <Dialog open onClose={onClose}>
      <DialogHeader icon="call" title="Pickup" onClose={onClose} />
      <DialogContent>
        <Typography color="textSecondary" sx={{ mb: 2 }} variant="body2">
          Pick up the call with an IVR campaign after this rule’s actions finish. The first pickup wins; later rules are
          skipped.
        </Typography>
        <CampaignSelect
          campaignTypes={[BackendCampaignTemplate.VoiceSurvey]}
          value={campaignId || ''}
          onChange={(id) => setCampaignId(Number(id))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="primary" disabled={!valid} variant="contained" onClick={() => onSave({ pickUp: action.pickUp })}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Pickup
